
export class Links {
  idLei: string;
  idItem: string;
  constructor(links?: Links) {
    this.idLei = links?.idLei;
    this.idItem = links?.idItem;
  }
}
